export const MENU = [
    {
        name: "Положение о конкурсе",
        link: "",
    },
    {
        name: "Регистрация",
        link: "registration",
    },
    // {
    //     name: "Материалы",
    //     link: "./materials",
    // }
];

export const SOCIALS = [
    {
        icon: "rmiac18",
        link: "https://rmiac18.ru/",
    },
    {
        icon: "vkontakte",
        link: "https://vk.com/rmiac18",
    },
    {
        icon: "telephone",
        link: "tel:73412787914",
    },
]
